const sanityClient = require('@sanity/client');
const client = sanityClient({
    projectId: 't6k5araq',
    dataset: 'production',
    token:
        'sklLvlmg6BGqCQFUUi00csJssoixrUx3YpGFELo654frgYcOSPdSZc0NsC0rZ0TLjPY5sHK1DWM5T6JclbDr6WEJEyqtnlMxjq4g2euYwLpqM27thqSzJCneByWxXWEgEp4LezURGWyMKApQ6TyUXEEsaCjQ8Ci1kPaCQj9bnO4Cb9lUOK8R', // or leave blank to be anonymous user
    useCdn: true // `false` if you want to ensure fresh data
});

// let date;
// let endDate = new Date("2019-11-20T00:00:01.264644+03:00");

export const SANITY = {
    setLike(doc) {
        return new Promise(resolve => {
            client.createOrReplace(doc).then(res => {
                resolve(res);
            });
        });
    },

    getLikesData(query) {
        return new Promise(resolve => {
            client.fetch(query).then(res => {
                resolve(res);
            });
        });
    }
};

export default SANITY;
